<template>
    <div>
        <input
                type="text"
                :value="computedValue"
                @change="onChange($event)"
                class="form-control"
        >&nbsp;
        <p>Enter provider ids separated by commas.</p>
    </div>
</template>

<script>
    export default {
        name: 'provider-input',
        props: {
            selectedValues : {
                type: String
            },

        },
        data () {
            return {
                value : null,
                labelText : null,
            };
        },
        computed: {
            computedValue: function () {
                return this.value !== null ? this.value : this.selectedValues;
            }
        },
        methods: {
            onChange: function (event) {
                this.value = event.target.value;
                this.$emit('update', this.value);
            },
        }


    }
</script>